import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles";

const style = (theme) => ({
  tooltip: {
    backgroundColor: theme.tooltipBGColor,
    color: theme.tooltipText,
    boxShadow: `0px 0px 2px 0px ${theme.tooltipBorderColor}`,
    borderRadius: 2,
    padding: 5,
    fontSize: 12,
    opacity: 1,
    wordBreak: "break-word",
  },
  popper: {
    opacity: 1,
  },
  tooltipPlacementRight: {},
  tooltipPlacementBottom: {},
});

const StyledToolTip = (props) => (
  <Tooltip
    enterDelay={props.enterDelay || 200}
    innerRef={(tooltipRef) => {
      if (tooltipRef && tooltipRef.childrenRef) {
        // When a element is clicked hide the tooltip, so it behaves like default browser tooltip
        tooltipRef.childrenRef.onmousedown = tooltipRef.handleLeave;
        // When element is clicked and cursor position is not changed, it shows default browser tooltip which shouldn't happen
        // below code will hide this scenario Eg: Locking of routes/ terminal access user commands
        // It doesn't affect other functionality of the tooltip
        tooltipRef.childrenRef.onmouseup = () =>
          tooltipRef.childrenRef.setAttribute("title", "");
      }
    }}
    {...props}
  />
);

export default withStyles(style)(StyledToolTip);
